import { render, staticRenderFns } from "./toast-v2.vue?vue&type=template&id=635d1888&scoped=true"
import script from "./toast-v2.vue?vue&type=script&lang=js"
export * from "./toast-v2.vue?vue&type=script&lang=js"
import style0 from "./toast-v2.vue?vue&type=style&index=0&id=635d1888&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635d1888",
  null
  
)

export default component.exports